import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const PayPerViewIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "PayPerViewIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.1829 13.9585C13.1829 14.1791 13.3627 14.3581 13.5825 14.3581H15.1809C15.8419 14.3581 16.3798 14.896 16.3798 15.5569C16.3798 16.2179 15.8419 16.7558 15.1809 16.7558H14.7813V17.1554C14.7813 17.376 14.6023 17.555 14.3817 17.555C14.1611 17.555 13.9821 17.376 13.9821 17.1554V16.7558H12.7832C12.5626 16.7558 12.3836 16.5768 12.3836 16.3562C12.3836 16.1356 12.5626 15.9566 12.7832 15.9566H15.1809C15.4007 15.9566 15.5806 15.7775 15.5806 15.5569C15.5806 15.3364 15.4007 15.1573 15.1809 15.1573H13.5825C12.9215 15.1573 12.3836 14.6194 12.3836 13.9585C12.3836 13.2975 12.9215 12.7596 13.5825 12.7596H13.9821V12.36C13.9821 12.1394 14.1611 11.9604 14.3817 11.9604C14.6023 11.9604 14.7813 12.1394 14.7813 12.36V12.7596H15.9802C16.2008 12.7596 16.3798 12.9386 16.3798 13.1592C16.3798 13.3798 16.2008 13.5588 15.9802 13.5588H13.5825C13.3627 13.5588 13.1829 13.7379 13.1829 13.9585ZM19.7766 14.7577C19.7766 17.7325 17.3565 20.1526 14.3817 20.1526C11.4069 20.1526 8.99564 17.7405 8.98765 14.7721C7.24691 14.0871 5.74115 12.8036 4.71653 11.1028C4.29853 10.3987 4.29853 9.5267 4.71493 8.82497C6.3166 6.15792 9.03321 4.56744 11.984 4.56744C14.9348 4.56744 17.6514 6.15792 19.2515 8.82258C19.6695 9.52671 19.6695 10.3987 19.2531 11.0996C19.1268 11.3162 18.9869 11.52 18.8398 11.7238C19.4305 12.5886 19.7766 13.6332 19.7766 14.7577ZM8.98685 9.96228C8.98685 8.30946 10.332 6.96514 11.984 6.96514C13.4402 6.96514 14.655 8.01054 14.9236 9.39002C16.1136 9.50911 17.1878 10.0214 18.023 10.7887C18.0886 10.6896 18.1597 10.5945 18.2204 10.4906C18.4146 10.1637 18.4146 9.76086 18.2228 9.43717C16.8418 7.13936 14.5096 5.76628 11.984 5.76628C9.4584 5.76628 7.12623 7.13937 5.74355 9.43957C5.55333 9.76086 5.55333 10.1637 5.74515 10.4874C6.57316 11.8613 7.75923 12.9242 9.13072 13.5389C9.26179 12.9762 9.48079 12.4487 9.77251 11.9684C9.27379 11.4217 8.98685 10.72 8.98685 9.96228ZM11.984 8.164C10.9929 8.164 10.1857 8.97043 10.1857 9.96228C10.1857 10.3419 10.3112 10.6952 10.5238 10.9949C11.351 10.1469 12.4548 9.57305 13.6872 9.4132C13.453 8.69149 12.7824 8.164 11.984 8.164ZM18.5777 14.7577C18.5777 12.4439 16.6955 10.5617 14.3817 10.5617C12.0679 10.5617 10.1857 12.4439 10.1857 14.7577C10.1857 17.0715 12.0679 18.9537 14.3817 18.9537C16.6955 18.9537 18.5777 17.0715 18.5777 14.7577Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default PayPerViewIcon;
